import React from 'react';
import {FiPlay,FiPause,FiArrowRight} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {motion} from 'framer-motion';

const EpisodeList=({episodes,currentEpisode,isPlaying,onPlay})=> {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold mb-6 text-gray-900">Fler avsnitt</h2>
      {episodes.map((episode,idx)=> {
        const isCurrentPlaying=currentEpisode?.url===episode.url && isPlaying;
        return (
          <motion.div
            initial={{opacity: 0,x: -10}}
            animate={{opacity: 1,x: 0}}
            transition={{delay: idx * 0.05}}
            key={episode.url}
            className={`group flex items-center gap-4 p-4 rounded-xl transition-all duration-200 border ${
              currentEpisode?.url===episode.url 
                ? 'bg-orange-50 border-[#F28423] ring-1 ring-[#F28423]' 
                : 'bg-white border-gray-100 hover:border-orange-200 hover:shadow-md'
            }`}
          >
            <button
              onClick={()=> onPlay(episode)}
              className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-colors ${
                currentEpisode?.url===episode.url 
                  ? 'bg-[#F28423] text-white' 
                  : 'bg-gray-100 text-gray-600 group-hover:bg-[#F28423] group-hover:text-white'
              }`}
            >
              <SafeIcon icon={isCurrentPlaying ? FiPause : FiPlay} className="w-5 h-5 ml-0.5" />
            </button>
            <div className="flex-grow min-w-0">
              <h3 className={`font-semibold text-lg truncate pr-4 ${
                currentEpisode?.url===episode.url 
                  ? 'text-[#F28423]' 
                  : 'text-gray-900'
              }`}>
                {episode.title}
              </h3>
              {episode.description && (
                <p className="text-sm text-gray-500 mt-1 line-clamp-1">
                  {episode.description}
                </p>
              )}
            </div>
          </motion.div>
        );
      })}
      {/* All Episodes Link */}
      <div className="pt-6 mt-6 border-t border-gray-100">
        <a
          href="https://open.spotify.com/show/5Z49zvPOisoSwhwojtUoCm?si=d15017e4ee6c4074"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full py-4 px-6 bg-white border-2 border-gray-100 rounded-xl text-gray-700 font-bold hover:border-[#F28423] hover:text-[#F28423] transition-all duration-200 group"
        >
          <span>Visa alla avsnitt</span>
          <SafeIcon icon={FiArrowRight} className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </div>
  );
};

export default EpisodeList;